var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-tooltip"},[_c('i-icon',{staticClass:"info-icon",class:_vm.iconClass,attrs:{"id":_vm.tooltipId,"symbol":_vm.symbol,"size":16}}),_c('i-tooltip',{attrs:{"target":`#${_vm.tooltipId}`,"title":_vm.title,"description":_vm.subtitle,"alignment":_vm.placement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }